module.exports = __webpack_public_path__ + "static/img/2025.318f985.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2025.jpg
// module id = 315
// module chunks = 0